import React from 'react';
import { toast } from 'sonner';

interface IToasterProps {
    heading: string;
    message: string;
    toastId: string;
    type?: string;
}

const toaster = ({ heading, message, toastId, type = 'info' }: IToasterProps) => {
    if (type === 'info') {
        toast.info(
            <div className='toast' role='alert'>
                <div className='toast-header'>
                    <h4>{heading}</h4>
                    <button className='toast-close' onClick={() => toast.dismiss()}></button>
                </div>
                <div className='toast-body'>
                    <span>{message}</span>
                </div>
            </div>,
            { id: toastId }
        );
    } else if (type === 'error') {
        toast.error(
            <div className='toast' role='alert'>
                <div className='toast-header'>
                    <h4>{heading}</h4>
                    <button className='toast-close' onClick={() => toast.dismiss()}></button>
                </div>
                <div className='toast-body'>
                    <span>{message}</span>
                </div>
            </div>,
            { id: toastId }
        );
    }

    return <></>;
};

export default toaster;
